/**
 * Merge list of objects by prioritizing `b`
 * @param a Some object with a key ['id']
 * @param b Some object with a key ['id']
 * @returns Merged list of objects, prioritizing the `b` list
 */
export function mergeListsById<A extends { id: string | number | null }>(a: A[], b: A[]): A[] {
  const mapA = new Map(a.map(item => [item.id, item]));
  const mapB = new Map(b.map(item => [item.id, item]));

  const allIds = new Set([...mapA.keys(), ...mapB.keys()])

  return Array.from(allIds).map(id => {
    const itemA = mapA.get(id);
    const itemB = mapB.get(id);
    if (itemA && itemB) {
      return { ...itemA, ...itemB }
    }
    return itemA ?? itemB!
  })
}

/**
 * Merge list of objects by prioritizing `b`
 * @param a Some object with a key ['id']
 * @param b Some object with a key ['id']
 * @param keyFunc A mapping function that takes the A object and maps it into a unique key
 * @returns Merged list of objects, prioritizing the `b` list
 */
export function mergeListsByKeyFunction<A extends Object>(a: A[], b: A[], keyFunc: (item: A) => string): A[] {
  const mapA = new Map(a.map(item => [keyFunc(item), item]));
  const mapB = new Map(b.map(item => [keyFunc(item), item]));

  const allIds = new Set([...mapA.keys(), ...mapB.keys()])

  return Array.from(allIds).map(id => {
    const itemA = mapA.get(id);
    const itemB = mapB.get(id);
    if (itemA && itemB) {
      return { ...itemA, ...itemB }
    }
    return itemA ?? itemB!
  })
}
